export enum InvoiceMode {
  DIRECT = "DIRECT",
  CHAIN = "CHAIN",
  RESELLER = "RESELLER",
}
